export const PRODUCT_FILTER_QUERY_KEYS = {
  CATEGORY: 'category',
  SUB_CATEGORY: 'sub_category',
  MANUFACTURER: 'manufacturer',
  POPULAR_CATEGORY: 'popular_category',
  TOP_SELLER: 'top_seller',
  SUGGESTED_PRODUCT: 'suggested-products',
  GUN_NEAR_YOU: 'gun_near_you',
  DISCOUNTED_PRODUCT: 'discounted-products',
  PROMOTED_PRODUCT: 'promoted-products',
  IS_NEW_ARRIVAL: 'is_new_arrival',
  IS_DISCOUNTED: 'is_discounted',
  CALIFORNIA_LEGAL: 'california_legal',
  INVENTORY: 'inventory',
  FFL: 'ffl',
  FILTER_BY: 'filter_by',
  SEARCH: 'search',
  SORT: 'sort',
  STATE: 'state',
  SHIPPING: 'shipping',
  ELIGIBILITY: 'eligibility',
  INTENDED_USE: 'intended_use',
  DISCOUNT: 'discount',
  COUPON: 'coupon',
} as const;

export const getProductFilters = (search: string) => {
  const params = new URLSearchParams(search);

  return {
    category: params.get(PRODUCT_FILTER_QUERY_KEYS.CATEGORY),
    manufacturer: params.get(PRODUCT_FILTER_QUERY_KEYS.MANUFACTURER),
  };
};

export const buildProductQueryString = (filters: {
  [PRODUCT_FILTER_QUERY_KEYS.CATEGORY]?: string | string[];
  [PRODUCT_FILTER_QUERY_KEYS.MANUFACTURER]?: string | string[];
  [PRODUCT_FILTER_QUERY_KEYS.SHIPPING]?: string | string[];
  [PRODUCT_FILTER_QUERY_KEYS.ELIGIBILITY]?: string | string[];
  [PRODUCT_FILTER_QUERY_KEYS.STATE]?: string;
  [PRODUCT_FILTER_QUERY_KEYS.SEARCH]?: string;
  [PRODUCT_FILTER_QUERY_KEYS.SORT]?: string;
  [PRODUCT_FILTER_QUERY_KEYS.IS_NEW_ARRIVAL]?: boolean;
  [PRODUCT_FILTER_QUERY_KEYS.IS_DISCOUNTED]?: boolean;
  [PRODUCT_FILTER_QUERY_KEYS.FFL]?: string | string[];
  [PRODUCT_FILTER_QUERY_KEYS.CALIFORNIA_LEGAL]?: boolean;
  [PRODUCT_FILTER_QUERY_KEYS.INVENTORY]?: string | string[];
}) => {
  const params = new URLSearchParams();

  if (filters.category) {
    if (Array.isArray(filters.category)) {
      filters.category.forEach((slug) => params.append(PRODUCT_FILTER_QUERY_KEYS.CATEGORY, slug));
    } else {
      params.set(PRODUCT_FILTER_QUERY_KEYS.CATEGORY, filters.category);
    }
  }
  if (filters.ffl) {
    if (Array.isArray(filters.ffl)) {
      filters.ffl.forEach((slug) => params.append(PRODUCT_FILTER_QUERY_KEYS.FFL, slug));
    } else {
      params.set(PRODUCT_FILTER_QUERY_KEYS.FFL, filters.ffl);
    }
  }

  if (filters.manufacturer) {
    if (Array.isArray(filters.manufacturer)) {
      filters.manufacturer.forEach((m) => params.append(PRODUCT_FILTER_QUERY_KEYS.MANUFACTURER, m));
    } else {
      params.set(PRODUCT_FILTER_QUERY_KEYS.MANUFACTURER, filters.manufacturer);
    }
  }

  if (filters.state) {
    params.set(PRODUCT_FILTER_QUERY_KEYS.STATE, filters.state);
  }
  if (filters.is_new_arrival) {
    params.set(PRODUCT_FILTER_QUERY_KEYS.IS_NEW_ARRIVAL, String(filters.is_new_arrival));
  }
  if (filters.is_discounted) {
    params.set(PRODUCT_FILTER_QUERY_KEYS.IS_DISCOUNTED, String(filters.is_discounted));
  }
  if (filters.california_legal) {
    params.set(PRODUCT_FILTER_QUERY_KEYS.CALIFORNIA_LEGAL, String(filters.california_legal));
  }
  if (filters.inventory) {
    if (Array.isArray(filters.inventory)) {
      filters.inventory.forEach((inv) => params.append(PRODUCT_FILTER_QUERY_KEYS.INVENTORY, inv));
    } else {
      params.set(PRODUCT_FILTER_QUERY_KEYS.INVENTORY, filters.inventory);
    }
  }

  if (filters.shipping) {
    if (Array.isArray(filters.shipping)) {
      filters.shipping.forEach((item) => params.append(PRODUCT_FILTER_QUERY_KEYS.SHIPPING, item));
    } else {
      params.set(PRODUCT_FILTER_QUERY_KEYS.SHIPPING, filters.shipping);
    }
  }

  if (filters.eligibility) {
    if (Array.isArray(filters.eligibility)) {
      filters.eligibility.forEach((item) =>
        params.append(PRODUCT_FILTER_QUERY_KEYS.ELIGIBILITY, item)
      );
    } else {
      params.set(PRODUCT_FILTER_QUERY_KEYS.ELIGIBILITY, filters.eligibility);
    }
  }

  if (filters.search) {
    params.set(PRODUCT_FILTER_QUERY_KEYS.SEARCH, filters.search);
  }

  if (filters.sort) {
    params.set(PRODUCT_FILTER_QUERY_KEYS.SORT, filters.sort);
  }

  return params.toString();
};
